(ns io.repliance.util.tree)

(defn sort-hierarchical
  "Sorts tree nodes by sort-keyfn & sort-comp and expands children of node under it, via depth-first walk with tree-seq.
  Each node gets a :depth value, starting from 0"
  ([nodes sort-keyfn sort-comp]
   (sort-hierarchical nodes sort-keyfn sort-comp :id))
  ([nodes sort-keyfn sort-comp id-key]
   (let [nodes-sorted (if (and sort-keyfn sort-comp) ;; TODO: This is bad, have to refactor the need away at callsites
                        (sort-by sort-keyfn sort-comp nodes)
                        nodes)
         parent-id->children (group-by :parent-id nodes-sorted)
         ids (set (map id-key nodes-sorted))
         roots (filter (fn [{:keys [parent-id]}]
                         (or
                          ;; nil parent-id
                          (nil? parent-id)
                          ;; parent-id present, but not found among nodes.
                          ;; Allows to deal with cases, where nodes list doesn't contain all parents.
                          (and parent-id
                                 (not (contains? ids parent-id)))))
                       nodes-sorted)
         ;parent->all-children (atom {})
         id->node (into {}
                        (map (juxt id-key identity))
                        nodes)]
     (->> roots
          (map #(assoc %
                       :tree/depth 0
                       :tree/ancestors #{}))
          (mapcat (fn [root]
                    (tree-seq #(seq (parent-id->children (get % id-key)))
                              (fn [parent]
                                (map (fn [child]
                                       ;(swap! parent->all-children update (get parent id-key) (fnil conj #{}) (get child id-key))
                                       (assoc child
                                              :tree/depth (inc (:tree/depth parent))
                                              :tree/ancestors (conj (:tree/ancestors parent) (get parent id-key))
                                              :tree/ancestor-nodes (conj (:tree/ancestor-nodes parent) (id->node (get parent id-key)))))
                                     (parent-id->children (get parent id-key))))
                              root)))
          (map (fn [node]
                 (assoc node
                        ;:tree/childrenOLD (get @parent->all-children (get node id-key))
                        :tree/children (->> (get parent-id->children (get node id-key))
                                            (map #(get % id-key))
                                            set))))))))

(defn find-root-id
  "Find the root-id, starting from a given node"
  ([id nodes]
   (find-root-id id nodes :id))
  ([id nodes id-key]
   (loop [id id]
     (let [parent-id (:parent-id (first (filter #(= id (get % id-key)) nodes)))]
       (if parent-id
         (recur parent-id)
         id)))))

(defn filter-tree
  "Returns a sequence of nodes under the tree from root-id, including the node with root-id.

  The result also contains the siblings of all nodes in the tree."
  ([root-id nodes]
   (filter-tree root-id nodes :id))
  ([root-id nodes id-key]
  (let [root-node (first (filter #(= root-id (get % id-key)) nodes))]
    (letfn [(helper [result parents]
              (if-let [children (seq (mapcat (fn [parent]
                                               (filter #(= (get parent id-key) (:parent-id %)) nodes))
                                             parents))]
                (helper (into result children) children)
                result))]
      (helper [root-node] [root-node])))))
